import request from '@/utils/request'

export function addNote(data) {
  return request({
    url: '/note-api/note',
    method: 'post',
    data
  })
}

export function getNoteList(params) {
  return request({
    url: '/note-api/note',
    method: 'get',
    params
  })
}
